import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TabMenu from "../components/companies/TabMenu";
import { fetchCustomerBilling, effectiveSeats } from "../api/pocketbase";

const InvoicePage = () => {
  const { id } = useParams();
  const [customer, setCustomer] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadBilling = async () => {
      try {
        const record = await fetchCustomerBilling(id);
        setCustomer(record);
      } catch (err) {
        console.error("Error loading invoice details:", err);
        setError("Failed to load invoice details.");
      }
    };
    if (id) loadBilling();
  }, [id]);

  const rows = customer
    ? [
        ["Company", customer.CompanyName || "-"],
        ["Legal / commercial name", customer.CommercialName || "-"],
        ["Invoice address", customer.InvoiceAddress || "-"],
        ["Invoice country", customer.expand?.InvoiceCountry?.Country || customer.expand?.Country?.Country || "-"],
        ["Legal business number", customer.LegalBN || "-"],
        ["Seats", effectiveSeats(customer)],
        ["Stripe customer id", customer.stripeCustId || "-"],
        ["Status", customer.active === false ? "Inactive" : "Active"],
      ]
    : [];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="space-y-6 px-3 py-4 sm:px-6 sm:py-6">
        <TabMenu />
        <div className="rounded-xl bg-white p-4 shadow-sm sm:p-6">
          <h2 className="text-lg font-semibold text-gray-900">Invoice details</h2>
          <p className="mt-1 text-sm text-gray-500">
            Billing fields from this customer record. There is no separate invoices collection in dbap.
          </p>
          {error ? (
            <p className="mt-4 text-sm text-red-600">{error}</p>
          ) : !customer ? (
            <p className="mt-4 text-sm text-gray-500">Loading...</p>
          ) : (
            <dl className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {rows.map(([label, value]) => (
                <div key={label} className="rounded-lg border border-gray-100 p-4">
                  <dt className="text-xs font-semibold uppercase tracking-wide text-gray-500">{label}</dt>
                  <dd className="mt-1 break-words text-sm text-gray-900">{value}</dd>
                </div>
              ))}
            </dl>
          )}
        </div>
      </div>
    </div>
  );
};

export default InvoicePage;
